import { render, staticRenderFns } from "./AppConsumerThanks.vue?vue&type=template&id=44c93f2a&"
import script from "./AppConsumerThanks.vue?vue&type=script&lang=js&"
export * from "./AppConsumerThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports